import {
  Customization,
  HeaderCustomization,
  LoginCustomization,
  MetaCustomization,
  RegisterCustomization,
  SideBarCustomization,
} from '@/models/customizationModels';
import { DispatchObject } from '@/models/globalModels';

import * as t from '../types';

// REDUX updates //
export const doCustomization = (custom: Customization) => (dispatch: DispatchObject<Customization>) => {
  dispatch({
    type: t.CUSTOMIZE_PORTAL,
    payload: custom,
  });
};

export const doCustomizeLogin = (custom: LoginCustomization) => (dispatch: DispatchObject<LoginCustomization>) => {
  dispatch({
    type: t.CUSTOMIZE_LOGIN,
    payload: { ...custom },
  });
};

export const doCustomizeHeader = (custom: HeaderCustomization) => (dispatch: DispatchObject<HeaderCustomization>) => {
  dispatch({
    type: t.CUSTOMIZE_HEADER,
    payload: { ...custom },
  });
};

export const doCustomizeSideBar = (custom: SideBarCustomization) => (dispatch: DispatchObject<SideBarCustomization>) => {
  dispatch({
    type: t.CUSTOMIZE_SIDEBAR_MENU,
    payload: { ...custom },
  });
};

export const doCustomizeMetaInfo = (custom: MetaCustomization) => (dispatch: DispatchObject<MetaCustomization>) => {
  dispatch({
    type: t.CUSTOMIZE_META,
    payload: { ...custom },
  });
};

export const doCustomizeRegister = (custom: RegisterCustomization) => (dispatch: DispatchObject<RegisterCustomization>) => {
  dispatch({
    type: t.CUSTOMIZE_REGISTER,
    payload: { ...custom },
  });
};
